export const LOGO_URL = "/cfcs-logo.jpeg";

export const BRAND = {
  short: "CFCS",
  name: "Central Florida Corporate Solutions",
  tagline: "Built Around Your Business. Delivered for Results.",
  email: "info@cfcorporatesolutions.com",
};
